import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';

const Badge = ({
	children,
	className = null,
	color = 'primary',
	shadow = null,
	rounded = null,
	isLight = false,
	style = {},
	...props
}) => {
	const { darkModeStatus } = useDarkMode();
	const isCustomColor = typeof color === 'string' && color.startsWith('#');

	return (
		<span
			className={classNames(
				'badge',
				{
					[`bg-${color}`]: !isLight && !isCustomColor,
					[`bg-l${darkModeStatus ? 'o25' : '10'}-${color}`]:
					isLight && !isCustomColor,
					[`text-${color}`]: isLight && !isCustomColor,
					[`shadow${shadow !== 'default' ? `-${shadow}` : ''}`]: !!shadow,
					[`rounded${rounded !== 'default' ? `-${rounded}` : ''}`]: rounded,
					'rounded-0':
						rounded === 'bottom'
						|| rounded === 'top'
						|| rounded === 'end'
						|| rounded === 'start'
						|| rounded === 0
						|| rounded === '0',
				},
				className,
			)}
			style={{
				...(isCustomColor ? { backgroundColor: color } : {}),
				...style,
			}}
			{...props}
		>
			{children}
		</span>
	);
};
Badge.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	color: PropTypes.string,
	style: PropTypes.object,
	rounded: PropTypes.oneOf([
		'default',
		0,
		1,
		2,
		3,
		'bottom',
		'top',
		'circle',
		'end',
		'start',
		'pill',
	]),
	shadow: PropTypes.oneOf([null, 'none', 'sm', 'default', 'lg']),
	isLight: PropTypes.bool,
};

export default Badge;
